import differenceInMonths from 'date-fns/differenceInMonths';
import parseJSON from 'date-fns/parseJSON';
import {
    User,
    UserSituationBooleanValue,
    UserSituationWhatIsYourCurrentPropertyGoalValue
} from '../../../graphql.generated';
import { UNSAVED_STORAGE_KEY } from '../hooks/useSaveGuestSituationData';

export enum UpdateYourSituationType {
    SELLER_FOLLOWUP = 'resurface_seller',
    NEEDS_UPDATE = 'update',
    NO_SITUATION_ANSWER = 'no_answer',
    NO_NEED_UPDATE = 'keep_existing_answer'
}

export const updateYourSituation = (
    user?: Partial<User> | null
): UpdateYourSituationType => {
    if (sessionStorage.getItem(UNSAVED_STORAGE_KEY)) {
        return UpdateYourSituationType.NO_NEED_UPDATE;
    }

    if (!user) {
        return UpdateYourSituationType.NO_NEED_UPDATE;
    }

    const propertyGoal = user.profile?.situationWhatIsYourCurrentPropertyGoal;
    const hasAnsweredBefore = user?.profile && propertyGoal !== null;

    const situationModuleLastShownAt = parseJSON(
        user?.traits?.situationModuleLastShownAt || new Date()
    );
    const lastShownComparedToNow = differenceInMonths(
        new Date(),
        situationModuleLastShownAt
    );

    const situationLastUpdatedAt = parseJSON(
        user?.traits?.situationLastUpdatedAt || new Date()
    );
    const lastUpdatedComparedToNow = differenceInMonths(
        new Date(),
        situationLastUpdatedAt
    );

    if (
        user.profile?.situationIsItAlreadyOnTheMarket ===
            UserSituationBooleanValue.No &&
        lastUpdatedComparedToNow >= 1
    ) {
        return UpdateYourSituationType.SELLER_FOLLOWUP;
    }

    if (
        (propertyGoal ===
            UserSituationWhatIsYourCurrentPropertyGoalValue.BuyAProperty ||
            propertyGoal ===
                UserSituationWhatIsYourCurrentPropertyGoalValue.SellMyProperty) &&
        lastUpdatedComparedToNow >= 6
    ) {
        return UpdateYourSituationType.NEEDS_UPDATE;
    }

    if (
        (propertyGoal ===
            UserSituationWhatIsYourCurrentPropertyGoalValue.RentAProperty ||
            propertyGoal ===
                UserSituationWhatIsYourCurrentPropertyGoalValue.Other ||
            propertyGoal ===
                UserSituationWhatIsYourCurrentPropertyGoalValue.TrackTheValueOfMyHome) &&
        lastUpdatedComparedToNow >= 12
    ) {
        return UpdateYourSituationType.NEEDS_UPDATE;
    }

    if (
        (user.traits?.yourSituationSkipped === true ||
            user.traits?.yourSituationSkipped === null) &&
        lastShownComparedToNow >= 1 &&
        !hasAnsweredBefore
    ) {
        return UpdateYourSituationType.NO_SITUATION_ANSWER;
    }

    if (
        (user.traits?.yourSituationSkipped === true ||
            user.traits?.yourSituationSkipped === null) &&
        lastShownComparedToNow >= 1 &&
        hasAnsweredBefore
    ) {
        return UpdateYourSituationType.NEEDS_UPDATE;
    }

    return UpdateYourSituationType.NO_NEED_UPDATE;
};
